module.exports = __webpack_public_path__ + "img/奖章2级@2x.4271911e.png";